import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import moment from 'moment';
import { withStyles } from '@mui/styles';
import { PubSub } from '../../utils/eventUtils';
import { getConnectorScoreHistory } from './ConnectorService';

const MSScoreHistory = ({
  classes,
  connectorType,
  connectorId,
  days,
  scoreType,
  q,
}: any) => {
  const [myData, setMyData] = useState(null);
  const [myScoreType, setMyScoreType] = useState(scoreType);
  const chartRef = useRef(null);

  useEffect(() => {
    Promise.all([
      getConnectorScoreHistory({ connectorType, connectorId, days }),
    ])
      .then((responses) => {
        const scoresHistory = responses[0].data.histogram;
        const data: any = [];
        scoresHistory.forEach((item: any, idx: any) => {
          const temp = {
            me: {},
            allTenants: {},
            totalSeats: {},
          };
          _.forEach(item, (value, key) => {
            if (typeof value === 'object') {
              if (key.includes('me_')) {
                if (value.value === null) {
                  temp.me[key] = data[idx - 1].me[key];
                } else {
                  temp.me[key] = value.value;
                }
              }

              if (key.includes('totalSeats_')) {
                if (value.value === null) {
                  temp.totalSeats[key] = data[idx - 1].totalSeats[key];
                } else {
                  temp.totalSeats[key] = value.value;
                }
              }

              if (key.includes('allTenants_')) {
                if (value.value === null) {
                  temp.allTenants[key] = data[idx - 1].allTenants[key];
                } else {
                  temp.allTenants[key] = value.value;
                }
              }
            } else {
              temp[key] = value;
            }
          });
          data.push(temp);
        });
        setMyData({
          scoresHistory: data,
        });
      })
      .catch(console.error.bind(console));

    const sub = PubSub.subscribe(
      'connectorDetails:scoreType-scoreHistory',
      (data: any) => {
        setMyScoreType(data);
        setMyData(null);
      }
    );
    const sub1 = PubSub.subscribe(
      'ConnectorDetails:toggleLines',
      (data: any) => {
        const { chart } = chartRef.current;
        const keys = Object.keys(data);
        keys.forEach((item, idx) => {
          chart.series[idx].setVisible(data[item]);
        });
      }
    );

    return () => {
      sub.remove();
      sub1.remove();
    };
  }, [q.before, q.after, connectorType, connectorId, days, myScoreType]);

  const options = {
    chart: {
      type: 'line',
      height: '165px',
    },
    yAxis: {
      title: {
        text: '',
      },
      lineColor: '#9192a4',
      lineWidth: 1,
      labels: {
        style: {
          color: '#c9cdd9',
        },
      },
    },
    title: {
      text: '',
    },
    xAxis: {
      type: 'datetime',
    },
    legend: {
      enabled: false,
    },
    series: [],
    credits: {
      enabled: false,
    },
    responsive: true,
  };

  const renderScoreHistorySection = () => {
    if (myData && myData.scoresHistory) {
      const { scoresHistory } = myData;
      const temp = {
        me: {
          name: '<span style="color: #fbc000;">Your Score</span>',
          data: [],
          color: '#fbc000',
        },
        totalSeats: {
          name: '<span style="color: #fa8072;">Similar seat Count</span>',
          data: [],
          color: '#fa8072',
        },
        allTenants: {
          name: '<span style="color: #69a8e8;">Global average</span>',
          data: [],
          color: '#69a8e8',
        },
      };
      scoresHistory.forEach((item: any) => {
        temp.me.data.push([
          moment.utc(item.time).valueOf(),
          item.me[`me_${myScoreType}`],
        ]);
        temp.totalSeats.data.push([
          moment.utc(item.time).valueOf(),
          item.totalSeats[`totalSeats_${myScoreType}`],
        ]);
        temp.allTenants.data.push([
          moment.utc(item.time).valueOf(),
          item.allTenants[`allTenants_${myScoreType}`],
        ]);
      });
      options.series.push(temp.me);
      options.series.push(temp.totalSeats);
      options.series.push(temp.allTenants);

      return (
        <HighchartsReact
          ref={chartRef}
          highcharts={Highcharts}
          options={options}
        />
      );
    }
    return (
      <img src="images/loading.svg" alt="" className={classes.loadingIcon} />
    );
  };

  if (myData) {
    return (
      <section className={classes.scoreHistoryContainer}>
        {renderScoreHistorySection()}
      </section>
    );
  }
  return null;
};

const styles = {
  chartsContainer: {
    width: '100%',
    height: '100%',
  },
  scoreHistoryContainer: {
    width: '100%',
    height: '100%',
    '& .highcharts-legend-item .highcharts-graph': {
      display: 'none',
    },
  },
};

export default withStyles(styles, { withTheme: true })(MSScoreHistory);
